const schedule = [
    {
        day: "Måndag 17 augusti",
        events: [
            {
                title: "Infofika",
                time: "14:00",
                place: "U11",
                description: "Oj Oj, jääättenyfiken N0llan är redan i Linköping. N0llan kanske har tusen frågor, eller bara vill träffa andra N0llan? På Infofikat kommer N0llan kunna träffa Faddrar som har svar, samt nyttig information som N0llan bör ta del av. Det är också ett perfekt tillfälle för alla N0llan att träffa varandra innan N0lle-P drar igång. Glöm inte att det finns jääääättegott fika också N0llan, passa på!",
            },
        ],
    },

    {
        day: "TiSdag 18 augusti",
        events: [
            {
                title: "Samling inför Upprop",
                time: "07:50",
                place: "MatNat-kullen",
                description: "Oj oj vilsna N0llan vill ju sjäääälvklart inte missa uppropet, jäääättetråkigt att missa kanske! Därför borde N0llan komma till MatNat-kullen, (58°23'59.7'N 15°34'41.9'E), Tisdagen den 18/8 klockan 07.50 och hälsa på faddrar och sina nya N0llan-kompisar innan faddrarna visar vägen till uppropssalen, C4. N0llan kanske även borde ta med sig vattenflaska, kanske jääääääääätte tråkigt att gå törstig under hela dagen!",
            },

            {
                title: "Scenshow",
                time: "10:30",
                place: "Campushallen",
                description: "Det kanske kommer ske något otroligt i Campushallen. N0llan kanske ska bege sig dit för ett minne de aldrig kommer att glömma.",
            },

            {
                title: "Lunch",
                time: "12:30",
                place: "M-grillen",
                description: "Så hungrig man kan vara efter ett sådant pirrigt upprop, men frukta ej. N0llans hunger har blivit hörd och det nalkas mat vid M-grillen tillsammans med era nya kompisar.",
            },

            {
                title: "Campusvandring",
                time: "15:00 - 20:00",
                place: "M-grillen",
                description: "N0llan ska få lära sig att hitta på campus. Faddrarna ska se till så N0llan får bekanta sig med sitt nya hem.",
            },

        ],
    },

    {
        day: "Onsdag 19 augusti",
        events: [
            {
                title: "MatNat-Vard",
                time: "12:15 - 13:00",
                place: "MatNat-kullen",
                description: "N0llan kanske inte vill äta själv och därför är det myyycket viktigt att N0llan infinner sig med varm matlåda på MatNat-kullen 12:15 för att kaanske få några uppdrag från Gudfadderiet.",
            },

            {
                title: "Uppstartsföreläsning Allmän kemi 1",
                time: "17:15 - 19:00",
                place: "C4",
                description: "Denna eftermiddag får N0llan chansen att gå på en kickoff föreläsning till kursen Allmän kemi 1. Mycket viktig och användbar för alla MatNat-N0llan att gå på.",
            },

            {
                title: "OMG-grillen",
                time: "19:00 - 21:00",
                place: "M-grillen",
                description: "Efter en lååång dag börjar klockan sakta närma sig kväll… och då kanske n0llan känner att det vore gott med något från grillen. Vem vet, det kanske även dyker upp lite oväntad underhållning under kvällens gång… Vore ju jäääätesynd för n0llan att missa denna kväll…",

            },

            {
                title: "DiskoTeKKFak",
                time: "21:00 - 01:00",
                place: "Kårhuset Kollektivet",
                description: "N0llan får chansen att dansa loss på KK med alla sina N0llan-kompisar.",
            },
        ],
    },

    {
        day: "Torsdag 20 augusti",
        events: [
            {
                title: "Lunchtävling: RockLing",
                time: "12:15 - 13:00",
                place: "Amfi",
                description: "TackLINGs mycket allsmäktiga lunchtävling",
            },

            {
                title: "Studentlivets dag",
                time: "17:15 - 21:00",
                place: "",
                description: "N0llan kanske vill ha böcker till skolan för att lära sig, kanske N0llan vill köpa begagnde böcker… N0llan kanske är avundsjuk på faddrarnas fina vinröda ovvar.. N0llan kanske vill prova ut sin storlek i den vinnnröda fina ovven. Har n0llan inte någon väska heller? Tur att styrelsen kanske säljer ursnygga ryggsäckar till N0llan… Detta vill N0llan inte missa, andra roliga saker föreningar kanske är där, vem vet?",
            },

            {
                title: "Häfvträning och tid för nolleuppdrag",
                time: "20:00 - 22:00",
                place: "",
                description: "Kanske N0llan vill träna på att hävva, eller kanske N0llan vill göra sina nolleuppdrag.",
            },

        ],
    },

    {
        day: "Fredag 21 augusti",
        events: [

            {
                title: "Lunchtävling: FYFA27",
                time: "12:15 - 13:00",
                place: "Amfi",
                description: "Y-Fadderiets mastodontlika lunchtävling",
            },

            {
                title: "Skördesitsen",
                time: "17:30 - 21:00",
                place: "Viagraparken",
                description: "Ack så hungrig och trött N0llan måste vara efter en så lång första vecka på LiU… Men frukta ej! Det allsmäktiga Gudfadderiet har ordnat en skörde-sittning med mat och dryck, bara för er skull! Kanske det har lagats suuuuupergod Morots- & Linssoppa åt N0llan, och en suuupergod Äppelpaj till efterrätt. N0llan kanske borde ta på sig sina skördekläder och se till att infinna sig i Viagra senast 17:45 för sin allra första temasittning. Kanske kan det vara så att N0llan och faddrar även får sällskap under kvällen…",
            },

            {
                title: "Nolledisco: STUrFPiRE",
                time: "21:00 - 01:00",
                place: "Kårallen",
                description: "N0llan kanske vill dansa loss på Kårallen med alla sina N0llan-kompisar.",
            },
        ],
    },

    {
        day: "Lördag 22 augusti - Söndag 23 augusti",
        events: [

            {
                title: "Hajken",
                time: "13:00 Lördag - 15:00 Söndag",
                place: "Hultsjön",
                description: "Dags för N0llan att bli ett med naturen, kanske. N0llan ska samlas vid Märkesbacken 13:00 för att sedan ta en myyycket fin cykeltur till en destination där mååånga överraskningar väntar. Suuuuperviktigt att N0llan kommer ihåg att packa med sig kläder efter väder (från regnväder till badväder) och att äta en stabil lunch innan avfärd. På plats får N0llan hamburgare till kvällsmat och gröt till frukost, skulle N0llan önska ytterliggare mellanmål bör N0llan packa med det. Möjlighet finns att stanna på en mindre affär på vägen ut.",
            },
        ],
    },

    {
        day: "Måndag 24 augusti",
        events: [

            {
                title: "Lunchtävling: D-rift",
                time: "12:15 - 13:00",
                place: "Märkesbacken",
                description: "STABENs blixtsnabba lunchtävling",
            },

            {
                title: "TBGFLing",
                time: "17:15 - 21:00",
                place: "Collo, C-huset",
                description: "N0llan kanske vill träffa andra N0llan från andra sektioner… Det har kommit ett ypperligt tillfälle att göra just detta. 17:15 kanske N0llan ska infinna sig på gräsplätten bredvid märkesbacken för ett fantaaastiskt förhäng. Sedan bär det av mot Colloseum för en sittning med tema “Oj jag kom fel!”.",
            },

            {
                title: "Nolledisco: CMYFLinGF",
                time: "21:00 - 01:00",
                place: "Kårallen",
                description: "N0llan kanske vill dansa loss på Kårallen med alla sina N0llan-kompisar.",
            },
        ],
    },

    {
        day: "Tisdag 25 augusti",
        events: [

            {
                title: "Lunchtävling: Turbinen",
                time: "12:15 - 13:00",
                place: "Amfi",
                description: "UrFadderiets uråldriga lunchtävling",
            },

            {
                title: "Stadsvandring",
                time: "15:00 - 20:00",
                place: "",
                description: "Faddrarna kommer att leda dig, N0llan, genom Linköping för att introducera staden. N0llan behöver ej frukta hunger, då Gudfadderiet bjuder på myyyyycket god mat… Suuuuperkul N0llan!",
            },
        ],
    },

    {
        day: "Onsdag 26 augusti",
        events: [

            {
                title: "Lunchtävling: Dragcamp",
                time: "12:15 - 13:00",
                place: "Amfi",
                description: "Clubmästeriets lunchtävling med mycket drag.",
            },

            {
                title: "München Hoben",
                time: "17:15 - 01:00",
                place: "Blå Havet",
                description: "Oktoberfest, fast i augusti, myyyycket trevligt N0llan.",
            },
            
        ],
    },

    {
        day: "Torsdag 27 augusti",
        events: [

            {
                title: "Lunchtävling: G-Force",
                time: "12:15 - 13:00",
                place: "Amfi",
                description: "Nu kommer det hända något mycket kul, N0llan. Gudfadderiets alldeles egna lunchtävling, G-force, mycket allsmäktigt! Detta vill N0llan inte missa.",
            },

            {
                title: "Faddrarnas dag",
                time: "17:15 - 21:00",
                place: "MatNat-kullen",
                description: "Faddrarna har planerat en dag för N0llan, mycket roligt N0llan, kanske N0llan verkligen vill uppleva detta.",
            },
        ],
    },

    {
        day: "Fredag 28 augusti",
        events: [

            {
                title: "MatNat-Vard",
                time: "12:15 - 13:00",
                place: "MatNat-kullen",
                description: "",
            },

            {
                title: "Häfvet",
                time: "15:15 - 16:00",
                place: "Amfi",
                description: "N0llan kanske vill heja på sina N0llan-kompisar som ska häfva.",
            },

            {
                title: "MegaYmpning",
                time: "16:00 - 17:00",
                place: "Amfi",
                description: "Har N0llan någonsin bevittnat ett helt hav av fadderister från TekFak bryta ut i sång och skaka loss? Skorna är snörade och höfterna redo för något n0llan sent kommer att glömma, kanske.",
            },

            {
                title: "Gubbens dag",
                time: "17:15 - 20:00",
                place: "Bakom C-huset",
                description: "Ojoj N0llan, ikväll kanske det händer något myyyycket speciellt. Kanske är det så att N0llan kommer att se dubbelt, eller till och med trippelt, när N0llan ser fadderister från parallella tidslinjer.",
            },
        ],
    },

    {
        day: "Söndag 30 augusti",
        events: [

            {
                title: "Pluggstuga",
                time: "14:00 - 17:00",
                place: "R19, C-huset",
                description: "N0llan kanske vill passa på att plugga inför kommande kurser, skolan är väldigt viktig N0llan.",
            },

            {
                title: "AktiVs spelkväll",
                time: "17:00 - 22:00",
                place: "T1 & T2, C-huset",
                description: "Oj oj oj, vad kan detta vara… En spelkväll med AktiV vill n0llan inte missa… Jääääteroliga spel kanske finns eller n0llan kanske har ett eget spel de vill dela med sig av. AktiV kanske bjuder på lite kaka och saft, det vill n0llan inte misssssssaaaa….",
            },
        ],
    },

    {
        day: "Måndag 31 augusti",
        events: [

            {
                title: "MatNat-Vard",
                time: "12:15 - 13:00",
                place: "Bakom C-huset",
                description: "Ojoj N0llan, kanske är det myyyyycket tråkigt att äta lunch ensam. Därför bör N0llan infinna sig bakom C-huset klockan 12:15 för att njuta av sin lunch tillsammans med andra N0llan. Kanske händer det även något underhållande.",
            },

            {
                title: "4-Verkeriets dag",
                time: "17:15 - 21:00",
                place: "Viagraparken",
                description: "I kväll ska N0llan få umgås lite extra med MatNats egna partydjur. De har förberett jäääätteroliga lekar för N0llans skull. Det blir skojigt, myyyycket skojigt. Kanske.",
            },
        ],
    },

    {
        day: "Tisdag 1 september",
        events: [

            {
                title: "N0llesitsen",
                time: "18:00 - 21:30",
                place: "Kårhuset Kollektivet",
                description: "Nu är tiden är kommen för N0llan att få reda på evighetens alla hemligheter, kanske. Inför denna kväll kanske N0llan vill ta på sig något N0llan känner sig extra fin i, men glöm inte glorian, N0llan. N0llan ska få gå på något myyycket roligt, nämligen finsittning på KK.",
            },

        ],
    },

    {
        day: "Lördag 5 september",
        events: [

            {
                title: "N0llefinalen",
                time: "22:00 - 03:00",
                place: "Kårallen",
                description: "Det börjar bli dags för N0llan att lämna glorian hemma och fira att ni äntligen är Ettan. Biljetter går att köpa på Orbi från 1 September ifall N0llan missade förköpet",
            },

        ],
    },

];

export default schedule;
